module.exports = __webpack_public_path__ + "static/media/next.78b351fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/com/sixdee/crbtportal/ui/toolkit/carousel/next.svg
// module id = 1082
// module chunks = 0